var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    _c(
      "div",
      { staticClass: "control", class: { "is-loading": _vm.isLoading } },
      [
        _c(
          "div",
          {
            staticClass: "select is-fullwidth",
            class: { "select-disabled": _vm.disabled }
          },
          [
            _c(
              "select",
              {
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  required: _vm.required
                },
                on: {
                  change: function($event) {
                    return _vm.$emit("change", $event)
                  }
                }
              },
              [
                _c("option", { domProps: { value: _vm.placeholderOption } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.placeholder) + "\n        "
                  )
                ]),
                _vm._l(_vm.options, function(option, index) {
                  return _c(
                    "option",
                    {
                      key: index,
                      domProps: {
                        value: option.value,
                        selected: option.value === _vm.value
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(option.label) + "\n        "
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }